var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.259 2.258c-.87.362-1.805.604-2.784.714 1-.562 1.77-1.453 2.131-2.513a10.18 10.18 0 01-3.08 1.103C19.643.677 18.382.126 16.988.126c-2.677 0-4.85 2.035-4.85 4.544 0 .357.043.704.126 1.036C8.234 5.516 4.662 3.707 2.27.96a4.308 4.308 0 00-.656 2.284c0 1.575.856 2.968 2.157 3.783a5.093 5.093 0 01-2.196-.57v.059c0 2.202 1.67 4.038 3.889 4.455a5.278 5.278 0 01-2.19.079c.617 1.803 2.408 3.118 4.53 3.155-1.66 1.219-3.75 1.944-6.022 1.944-.392 0-.778-.021-1.157-.063a14.41 14.41 0 007.433 2.042c8.919 0 13.796-6.925 13.796-12.93 0-.197-.006-.392-.015-.588a9.564 9.564 0 002.42-2.351z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "img/_/_/views/utils/components/Footer/assets/svg/twitter-white.svg";
export { SvgTwitterWhite as ReactComponent };